import type { ReactNode } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

interface ReCaptchaV3FeatureConfig {
	enabled: boolean
	siteKey: string
	enterprise: boolean
}

interface ReCaptchaV3ProviderParams {
	featureConfig: ReCaptchaV3FeatureConfig
	children: ReactNode
}

const ReCaptchaV3Provider = ({ featureConfig: config, children }: ReCaptchaV3ProviderParams) => {
	if (config && config.enabled) {
		return (
			<GoogleReCaptchaProvider
				reCaptchaKey={config.siteKey}
				useEnterprise={config.enterprise}
				scriptProps={{
					async: true,
					defer: true,
				}}
			>
				{children}
			</GoogleReCaptchaProvider>
		)
	} 
		return children
	
}

export default ReCaptchaV3Provider
